module.exports = __webpack_public_path__ + "static/assets/03ef1b0818e7a1222012b7f61079e2dc.gif";